import type { FC } from 'react';
import React from 'react';
import { Body, Flex, Heading } from '@edreamsodigeo/prisma-design-system';

import { DurationWithIcon } from '@/components/Duration/DurationWithIcon';

interface SegmentTitleMapItineraryProps {
  title: string;
  duration: number | undefined;
  indx: number;
}

const SegmentTitleMapItinerary: FC<SegmentTitleMapItineraryProps> = ({
  title,
  duration,
  indx,
}) => {
  return (
    <Flex
      justifyContent="space-between"
      mt={indx === 0 ? '1x_small' : '1x_big'}
      mb="1x_big"
    >
      <Heading type="2" weight="medium">
        {title}
      </Heading>
      <Body type="base" color="neutral.80">
        <DurationWithIcon
          duration={duration ?? 0}
          color="neutral.80"
          weight="normal"
          type="base"
        />
      </Body>
    </Flex>
  );
};

export default SegmentTitleMapItinerary;
